import store from '@/store'

export default function useBankAccounts() {
  function findBank(id) {
    return store.getters['userStore/getBankById'](id)
  }

  return { findBank }
}
